import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    width: '100%',
    paddingTop: `calc(0.5rem + ${theme.size.base})`,
    paddingBottom: '0.5rem',
    overflowY: 'hidden',

    '&:hover': {
      overflowY: 'overlay'
    },

    '&:not(:last-child)': {
      marginRight: '15px'
    },

    '& > *': {
      outline: 'none',
      border: 'none',
      height: '100%'
    },

    '& .text': {
      width: '100%',
      height: 'auto',
      backgroundColor: 'transparent',
      color: '#323436',
      resize: 'none',

      '& div > div > textarea.text__input': {
        padding: '0 !important'
      },

      '& div > div > .text__highlighter': {
        height: 'auto !important'
      },

      '& div > .text__control ': {
        height: 'auto !important'
      }
    },

    '& > .count': {
      position: 'absolute',
      right: 'calc(50% + 1.5rem)',
      top: '4px',
      height: 'auto',
      color: 'rgba(50, 52, 54, 0.35)',
      userSelect: 'none',

      [theme.breakpoints.down('md')]: {
        right: '2.5rem'
      }
    }
  },

  subtasks: {
    display: 'flex',
    flexDirection: 'column'
  },

  subtask: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',
    height: '16px',
    paddingLeft: '24px'
  }
}))

export default useStyles
